import React, {FormEvent} from "react";
import '../../../styles/components/onboarding/create-account/create-account-page.scss';
import {navigate} from "../../../services/navigation/navigation";
import {appPagePaths, onboardingImagesSource,} from "../../../config/config";
import Button from "../../common/Button";
import Form from "../../common/Form";
import onboarding from "../../../services/onboarding/onboarding";
import OrientationWebpImg from "../../common/OrientationWebpImg";
import ExternalLink from "../../common/ExternalLink";
import {WhenDeviceIOS} from "../../conditional/device/os/WhenDeviceIOS";
import {useMicrophone} from "../../../hooks/microphone.hook";
import {baseUrlForWebsite} from "../../../client/PlaygroundSettings";
import {FormFieldTextInput} from "../../common/FormFieldTextInput";
import {inAppAnalyticsService} from "../../../services/inAppAnalyticsService";

const screenClass = 'onboarding/create-account';

export default function CreateAccountPage() {
  const microphone = useMicrophone();

  const createAccountForm = onboarding.getCreateAccountForm();
  const isLoading = onboarding.useCreateAccountLoadingHook().isLoading;
  const {password, email} = createAccountForm;
  function handleSubmit(e: FormEvent){
    if(!isLoading){
      // Fire here (not on the button's onClick) so the funnel events are captured
      // for both pointer clicks and keyboard (Enter) form submissions.
      inAppAnalyticsService.onButton_press('create-account-submit', {screenClass});
      inAppAnalyticsService.onCreateAccount_tap({screenClass, destination: 'in_app'});
      void onboarding.createAccountUsingCreateAccountForm(microphone.isAvailable);
    }
    e.preventDefault();
  }
  const signInButton = createSignInButton(microphone.isAvailable);
  return (
    <div className="create-account-page">
      <header className="top">
        <OrientationWebpImg srcPortrait={onboardingImagesSource.womanAtKeyboardPortrait} srcLandscape={onboardingImagesSource.womanAtKeyboardLandscape}/>
        <div className="overlay-text">
          <h1>Create an account</h1>
          <WhenDeviceIOS>
            <p className="trial-callout">14-day free trial</p>
          </WhenDeviceIOS>
        </div>
      </header>
      <div className={"content-and-navigation"}>
        <div className="content">
          <h1 className="page-header-text">Create an account</h1>
          <WhenDeviceIOS>
            <p className="trial-callout">14-day free trial</p>
          </WhenDeviceIOS>
          <Form onSubmit={handleSubmit}>
            <FormFieldTextInput
              label={"Email address"}
              autoComplete={"email"}
              isRequired={true}
              formField={email}
              isEmail={true}
            />
            <FormFieldTextInput
              label={"Password"}
              note={"Passwords must contain at least 8 characters."}
              autoComplete={"new-password"}
              isRequired={true}
              formField={password}
              isPassword={true}
            />
            <Button
              isLoading={isLoading}
              buttonType={"secondary"}
              text="Create Account"
              // Submit-type button; the funnel events fire in the form's handleSubmit
              // so click and Enter submissions are both captured.
              onClick={() => {}}
            />

          </Form>
          <div className="terms">
            By creating an account, you are agreeing to our&nbsp;
            <ExternalLink url={`${baseUrlForWebsite}/about/terms-and-conditions`}
              title={"Terms of Use"}
              onClick={() => inAppAnalyticsService.onButton_press('create-account-terms', {screenClass})}/>,&nbsp;
            <ExternalLink url={`${baseUrlForWebsite}/about/privacy-policy`}
              title={"Privacy Policy"}
              onClick={() => inAppAnalyticsService.onButton_press('create-account-privacy', {screenClass})}/>,&nbsp;
            <ExternalLink url={`${baseUrlForWebsite}/about/license-agreement`}
              title={"License Agreement"}
              onClick={() => inAppAnalyticsService.onButton_press('create-account-license', {screenClass})}/>
          </div>
        </div>
        <div className="navigation">
          {signInButton}
        </div>
      </div>
    </div>
  );
}

function createSignInButton(isMicrophoneAvailable: boolean){
  const redirectTo = isMicrophoneAvailable
    ? appPagePaths.onboarding_setupFeedback_setupFeedbackAndScoring
    : appPagePaths.setupYourKeyboardPage;
  return <div className="text-and-button">
    <div className="text">Already have an account?</div>
    <Button text="Sign In" buttonType={"primary"} onClick={()=>{
      inAppAnalyticsService.onButton_press('create-account-sign-in', {screenClass});
      inAppAnalyticsService.onSignIn_tap({screenClass});
      navigate(`${appPagePaths.signIn}?route-to-page-after-sign-in=${redirectTo}`);
    }}/>
  </div>
}